'use client'

import theme, {media} from '@/src/config/theme'
import styled from 'styled-components'
import {ContainerStyles, ContentMainStyles} from '@/src/shared/ui/layout/ui/content.styles'

export const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: space-between;

  align-items: baseline;
  min-height: 100vh;
  width: 100%;
`

export const Main = styled.main`
  ${ContentMainStyles}
`

export const Meta = styled.div`
  &,
  & > *,
  &.meta {
    width: 100%;
  }
  
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const Container = styled.div`
  padding-top: ${theme.token.layout.pagePadding}px;
  padding-bottom: ${theme.token.layout.pagePadding}px;
  
  display: flex;
  flex-direction: column;
  
  &:not(.no-padding) {
    gap: 10px;  
  }
  
  &.center {
    margin: auto;
  }
  
  ${ContainerStyles}
  
  &.padding-20 {
    padding-left: 20px;
    padding-right: 20px;
  }
  
  @media ${media.md} {
    padding-top: ${theme.token.layout.pagePadding * 2}px;
    padding-bottom: ${theme.token.layout.pagePadding * 2}px;
  }
`

export const MobileBottomMenu = styled.div`
  z-index: 2004;

  width: 100%;

  position: fixed;
  bottom: 0;
  left: 0;

  display: flex;
  justify-content: center;

  background: ${theme.colors.primary};
`

export const MobileBottomContainer = styled.div`
  width: 100%;
  justify-content: space-evenly;
  padding: 17px;

  display: flex;
  align-items: self-end;
  column-gap: 9px;

  @media (max-width: 359.98px) {
    padding: 10px 6px;
    column-gap: 4px;
  }

  @media ${media.md} {
    display: none;
  }
`

export const MobileBottomButton = styled.button`
  position: relative;
  padding-left: 1px;
  padding-right: 1px;

  color: ${theme.colors.text};

  display: flex;
  align-items: center;
  flex-direction: column;

  span {
    font-size: 0.875rem;
  }

  img {
    max-height: 24px;
  }
`

export const IconBasket = styled.svg`
  path {
    stroke: ${theme.colors.dark};
  }
`

export const BasketCount = styled.div`
  position: absolute;
  right: -10px;
  top: 0;
  font-size: 14px;
  background: white;
  border-radius: 100%;
  color: black;
  padding: 2px;
  min-width: 20px;
  min-height: 20px;

  display: flex;
  align-items: center;
  justify-content: center;
`


export const FavouriteCount = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  font-size: 14px;
  background: white;
  border-radius: 100%;
  color: black;
  padding: 2px;
  min-width: 20px;
  min-height: 20px;

  display: flex;
  align-items: center;
  justify-content: center;
`
